import { apiRequest } from "./instance";

export { apiRequest, refreshApiRequest, api } from "./instance";

// Deprecated
export default apiRequest;
